<!-- 财务管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>流水类型</span>
          <el-select
            v-model="queryInfo.type"
            @change="changeType"
            size="small"
            class="w100Select"
          >
            <el-option label="支出" :value="1"></el-option>
            <el-option label="收入" :value="2"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>交易类型</span>
          <el-select
            v-model="queryInfo.transaction"
            size="small"
            class="w200Select"
          >
            <el-option label="请选择" :value="-1"></el-option>
            <el-option
              v-for="(item, index) in choiceArr"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>订单号</span>
          <el-input
            class="w180"
            v-model="queryInfo.order_no"
            clearable
            size="small"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            @change="selectData"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <!-- <el-button type="primary" size="small" @click="queryTable('search')"
          >搜索</el-button
        >
        <el-button type="warning" size="small" @click="resetQuery"
          >重置</el-button
        > -->
          <MyButton
            value="搜索"
            size="medium"
            icon="el-icon-search"
            type="1"
            @click="queryTable('search')"
          ></MyButton>
          <MyButton
            value="重置"
            size="medium"
            type="2"
            @click="resetQuery"
          ></MyButton>
        </div>
      </div>
      <div class="table">
        <TableComponents :columns="columns" :tableData="tableList">
          <template slot="feeAll" slot-scope="{ row }">
            {{ row.feeAll }}
          </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import financialApi from "@/api/financial.js";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "financialManage",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    return {
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        type: 1, //流水类型 1支出 2收入
        transaction: -1, //交易类型 1视频课程2题库会员3学籍卡4vip学员 5退款6充值
        order_id: "", //订单号
        created_start_time: "", //创建开始时间
        created_end_time: "", //创建结束时间
        // createTime:[]
      },
      columns: [
        //列数据
        { label: "流水ID", prop: "id" },
        { label: "开通人（机构账号登录）", prop: "tob_users_id" },
        { label: "创建时间", prop: "created_at" },
        { label: "流水类型", prop: "type_name" },
        { label: "交易类型", prop: "transaction_name" },
        { label: "订单号", prop: "order_no" },
        { label: "学员账号", prop: "username" },
        { label: "金额", prop: "feeAll", isMyself: true },
        { label: "机构余额", prop: "group_fee" },
      ],
      tableList: [],

      // 读取文件
      fileData: "",
      timeFrame: [],
      zc_transaction_types: [],
      sr_transaction_types: []
    };
  },
  created() {
    if (this.$route.query && this.$route.query.order_no) {
      this.queryInfo.order_no = this.$route.query.order_no;
    }
    if (this.$route.query && this.$route.query.type) {
      this.queryInfo.type = 2;
      this.queryInfo.transaction = -1;
    }
    this.queryTable();
  },
  computed: {
    choiceArr() {
      if (this.queryInfo.type == 1) {
        return this.zc_transaction_types;
      } else {
        return this.sr_transaction_types;
      }
    },
  },
  watch: {
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },
  },
  methods: {
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      const res = await financialApi.flowingList(this.queryInfo);
      if (res.code == 200) {
        this.zc_transaction_types = res.data.zc_transaction_types
        this.sr_transaction_types = res.data.sr_transaction_types
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;
        this.tableList.forEach((item, index) => {
          // this.tableList[index].finType = item.type == 1 ? "支出" : "收入";
          // let _noti = "";
          // switch (item.transaction) {
          //   case 1:
          //     _noti = "视频课程";
          //     break;
          //   case 2:
          //     _noti = "题库会员";
          //     break;
          //   case 3:
          //     _noti = "学籍卡";
          //     break;
          //   case 4:
          //     _noti = "vip学员";
          //     break;
          //   case 5:
          //     _noti = "退款";
          //     break;
          //   case 6:
          //     _noti = "充值";
          //     break;
          //   case 7:
          //     _noti = "平台号码导入";
          //     break;
          //   case 8:
          //     _noti = "平台号码导入通话";
          //     break;
          //   case 9:
          //     _noti = "自有号码通话";
          //     break;
          //   case 10:
          //     _noti = "套餐";
          //     break;
          // }
          // this.tableList[index].finTransaction = _noti;

          if (
            this.tableList[index].transaction == 13 &&
            this.tableList[index].type == 1 &&
            this.tableList[index].remark
          ) {
            this.tableList[index].transaction_name =
              this.tableList[index].transaction_name +
              "(" +
              this.tableList[index].remark +
              ")";
          }

          if (item.qorder) {
            this.tableList[index].order_no =
              this.tableList[index].qorder.order_no;
            this.tableList[index].username =
              this.tableList[index].qorder.user_no;
          }

          this.tableList[index].feeAll =
            this.tableList[index].fee + this.tableList[index].give_fee_text;

          console.log("feeAll", this.tableList[index].feeAll);
        });
      } else {
        this.$message.error(res.message);
      }
    },

    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },

    // 批量导入
    // 文件选择回调
    onChange(file, fileList) {
      //  fileList);
      this.fileData = file; // 保存当前选择文件
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      let that = this;
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = that.XLSX.read(data, {
            type: "binary",
            raw: true,
          });
          if (workbook.SheetNames.length >= 1) {
            this.$message.success("表格导入成功");
          }
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = that.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          that.outputs = []; //清空接收数据
          let _list = [];
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              realname: ws[i]["真实姓名（必填）【至少两个中文汉字】"],
              mobile: ws[i]["手机号"],
              id_card: ws[i]["身份证号"],
              remark: ws[i]["备注"],
              tel: ws[i]["用户名【老学员还需要填写用户名，即登录账号】"],
            };
            _list.unshift(sheetData);
          }
          //  444,_list);
          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    // 选择日期
    selectData(e) {
      //  e);
      if (e) {
        this.queryInfo.created_start_time = e[0];
        this.queryInfo.created_end_time = e[1];
      } else {
        this.queryInfo.created_start_time = "";
        this.queryInfo.created_end_time = "";
      }
    },
    // 重置
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        type: 1, //流水类型 1支出 2收入
        transaction: -1, //交易类型 1视频课程2题库会员3学籍卡4vip学员 5退款6充值
        order_id: "", //订单号
        created_start_time: "", //创建开始时间
        created_end_time: "", //创建结束时间
        // createTime:[]
      };
      this.queryTable();
    },
    // 切换
    changeType() {
      if (this.queryInfo.type == 1) {
        this.queryInfo.transaction = -1;
      } else {
        this.queryInfo.transaction = -1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
</style>
